import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

/** 업체 블록 필드 라벨(레거시 span.d-block.mb-5) */
export const ExpenseFieldLabel = styled('span')({
  display: 'block',
  marginBottom: 5,
  fontSize: 14,
  lineHeight: '20px',
  color: 'var(--dk-text, #1A1A1A)',
  '& > .required': {
    marginLeft: 4,
    color: 'var(--dk-danger, #F55060)',
  },
});

/** 업체 블록(레거시 .expense-info-item) */
export const ExpenseVendorCard = styled(Box)({
  position: 'relative',
  marginBottom: 15,
  padding: 16,
  borderRadius: 4,
  backgroundColor: 'var(--dk-bg-subtle, #F9FAFB)',
  '& > .field': { marginBottom: 15 },
});
